import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import PartsAndAccessories from './pages/parts-and-accessories';
import ServiceBooking from './pages/service-booking';
import Contact from './pages/contact';
import CreditSimulation from './pages/credit-simulation';
import MotorHonda from './pages/motor-honda';
import Homepage from './pages/homepage';
import MotorDetail from './pages/motor-honda/components/detail-motor';
import OliAndAccessories from "./pages/oli";
import ApparelAndAccessories from "./pages/apparel-aksesoris";
import PromoPage from "./pages/promo";
import AdminLogin from "./pages/promo/login";
import AdminDashboard from "./pages/promo/admin";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/produk/suku-cadang" element={<PartsAndAccessories />} />
        <Route path="/service-booking" element={<ServiceBooking />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/credit-simulation" element={<CreditSimulation />} />
        <Route path="/produk/motor" element={<MotorHonda />} />
        <Route path="/produk/motor/:slug" element={<MotorDetail />} />
        <Route path="/produk/oli" element={<OliAndAccessories/>} />
        <Route path="/produk/apparel-aksesoris" element={<ApparelAndAccessories/>} />
        <Route path="/promo" element={<PromoPage />} />
        <Route path="/promo/login" element={<AdminLogin />} />
        <Route path="/promo/admin" element={<AdminDashboard />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
